import React from 'react';
import { connect } from 'react-redux';
import { LazyImage } from 'project/lazy-image';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';

class LiveHeaderTitle extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
    }

    render() {
        const { liveScanner } = this.props;

        if (!liveScanner || !liveScanner.liveHeader) return null;

        const model = liveScanner.liveHeader;

        return (
            <a className="live-header-title" href={model.linkUrl}>
                <div className="live-header-title__logo">
                    <LazyImage image={model.eventLogoSrc} />
                </div>
                <div className="live-header-title__content">
                    <b>{model.title}&nbsp;</b>
                    <span className="live-header-title__subtitle">{model.subtitle}</span>
                </div>
            </a>
        );
    }
}

const mapStateToProps = (state) => ({
    liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
});

const ALiveHeaderTitleContainer = connect(
    mapStateToProps,
    null
)(LiveHeaderTitle);

export default ALiveHeaderTitleContainer;
